<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Custom Content') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-card outlined class="pa-4">
                <v-card-title class="text-subtitle-1 px-0 pt-0">
                  {{ $t('Custom Scripts') }}
                </v-card-title>

                <v-textarea
                  v-model.trim="formData.injected_scripts"
                  dense
                  outlined
                  :rules="[validateJavaScript]"
                  :label="$t('Custom Scripts')"
                  :hint="
                    $t(
                      'Add custom JavaScript that will be executed on the booking page'
                    )
                  "
                  persistent-hint
                  @input="updateForm"
                />

                <v-alert type="warning" dense text class="mt-4">
                  {{
                    $t(
                      'Warning: Custom scripts can affect the functionality of the booking page. Use with caution.'
                    )
                  }}
                </v-alert>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'CustomContent',

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        injected_scripts: this.bookingEngineSetting.injected_scripts || '',
      },
    }
  },

  methods: {
    validateJavaScript(value) {
      if (!value) return true
      try {
        // Try to parse the JavaScript code
        new Function(value)
        return true
      } catch (e) {
        return 'Invalid JavaScript syntax'
      }
    },

    updateForm() {
      if (this.$refs.form.validate()) {
        this.$emit('update:setting', this.formData)
      }
    },

    validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>
